export const isMac = navigator && navigator.appVersion.indexOf("Mac") !== -1;
